import { useQuery } from "@apollo/client";

import {
  GetCampaignStatsQuery,
  GetCampaignStatsQueryVariables,
} from "~frontend/__generated__/graphql";
import { GET_CAMPAIGN_STATS } from "~frontend/graphql/campaigns";

export const useCampaignStats = (
  campaignShortId: number
): CampaignStatsForDetailQueryResult => {
  const { error, loading, data } = useQuery<
    GetCampaignStatsQuery,
    GetCampaignStatsQueryVariables
  >(GET_CAMPAIGN_STATS, {
    variables: {
      input: {
        shortId: campaignShortId,
      },
    },
    pollInterval: 5 * 1000,
  });

  if (loading) {
    return { state: "loading" };
  } else if (error || !data?.getCampaignByShortId?.statsForDetail) {
    return { state: "error" };
  } else {
    return { state: "loaded", data: data.getCampaignByShortId.statsForDetail };
  }
};

export type CampaignStatsForDetailQueryResult =
  | {
      state: "loading";
    }
  | {
      state: "error";
    }
  | {
      state: "loaded";
      data: NonNullable<
        GetCampaignStatsQuery["getCampaignByShortId"]["statsForDetail"]
      >;
    };

export type StatsQueryData =
  | NonNullable<GetCampaignStatsQuery["getCampaignByShortId"]["statsForDetail"]>
  | NonNullable<
      GetCampaignStatsQuery["getCampaignByShortId"]["statsForDetail"]
    >["variants"][0];

export type StatsQueryResult =
  | {
      state: "loading";
    }
  | {
      state: "error";
    }
  | {
      state: "loaded";
      data: StatsQueryData;
    };
